import React, {
  createContext, useContext, useState, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';

import Api from 'services/api';

const ApiStatusContext = createContext();

const ApiStatusProvider = ({ children }) => {
  const [configurationStatus, setConfigurationStatus] = useState({});
  const [progressStatus, setProgressStatus] = useState({});
  const closeSocketRef = useRef();
  const publishStatusListenerRef = useRef();

  const callPublishStatusListener = (content) => publishStatusListenerRef?.current(content);

  useEffect(() => {
    const checkApiStatus = async () => {
      const closeSocket = Api.apiStatusSocket(
        setConfigurationStatus, setProgressStatus, callPublishStatusListener,
      );
      closeSocketRef.current = closeSocket;
    };

    checkApiStatus();

    return () => {
      if (closeSocketRef.current) {
        closeSocketRef.current();
      }
    };
  }, []);

  return (
    <ApiStatusContext.Provider
      value={{ configurationStatus, progressStatus, publishStatusListenerRef }}
    >
      {children}
    </ApiStatusContext.Provider>
  );
};

ApiStatusProvider.propTypes = {
  children: PropTypes.node,
};

ApiStatusProvider.defaultProps = {
  children: null,
};

export const useConfigurationStatus = () => {
  const { configurationStatus } = useContext(ApiStatusContext);
  return configurationStatus;
};

export const useProgressStatus = () => {
  const { progressStatus } = useContext(ApiStatusContext);
  return progressStatus;
};

export const usePublishStatus = (publishStatusListener) => {
  const { publishStatusListenerRef } = useContext(ApiStatusContext);
  publishStatusListenerRef.current = publishStatusListener;
};

export default ApiStatusProvider;
